<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-coupon-line  me-1 text-primary"></i>Vouchers
                </h5>
              </div>
              <div class="col">
                <div ngbDropdown autoClose="manual" class="d-inline-block" #dropdown="ngbDropdown">
                  <button type="button" class="btn btn-outline-secondary" id="dropdownForm1" ngbDropdownToggle>
                    <i class="bx bx-filter"></i> Filter
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                    <div class="p-3">
                      <div class="mb-2">
                        <label><i class="bx bx-filter mr-1"></i>Date Filter</label>
                        <ng-select class="ng-filter" [clearable]="false" [searchable]="false"
                          [(ngModel)]="selectedFilter">
                          <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                        </ng-select>
                      </div>

                      <ng-container *ngIf="selectedFilter === 'Custom'">
                        <div class="mb-2">
                          <label><i class="bx bx-calendar mr-1"></i>From Date</label>
                          <input type="date" [(ngModel)]="fromDate" class="form-control">
                        </div>
                        <div class="mb-2">
                          <label><i class="bx bx-calendar mr-1"></i>To Date</label>
                          <input type="date" [(ngModel)]="toDate" class="form-control">
                        </div>
                      </ng-container>

                      <button type="button" (click)="filterAndFetchTransation(selectedFilter, dropdown)"
                        class="btn btn-secondary w-100">
                        Search
                      </button>
                    </div>
                    <div class="dropdown-divider"></div>
                  </div>
                </div>
                <button type="button" class="btn btn-success btn-sm ms-1" style="height: 37px; width: 39px;"
                  ngbTooltip="Download as Excel" placement="top" container="body" (click)="downloadExcel()">
                  <i class="bx bx-download"></i>
                </button>
              </div>
              <div class="col-sm-12 col-md-auto">
                <button type="button" class="btn btn-secondary" (click)="upsertVoucher()" id="add-btn"
                  [ngClass]="{'not-allowed':!privilege.canEdit}"
                  [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): finance.voucher.edit' : ''">
                  <i class="bx bx-plus"></i> Add Voucher
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="70"></th>
                  <th scope="col" width="400">Date</th>
                  <th scope="col" width="400" class="text-center">Voucher No</th>
                  <th scope="col" width="500" class="text-center">Type</th>
                  <th scope="col" width="500" class="text-center">Total Debit</th>
                  <th scope="col" width="500" class="text-center">Total Credit</th>
                  <th scope="col" width="300">Voucher Status</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let voucher of tableData.content | search : 'name' : searchKeyword; let i=index">
                  <tr>
                    <td>{{i+1}}.</td>
                    <td>
                      <i class="bx" [ngClass]="voucher.expanded ? 'bx-chevron-down' : 'bx-chevron-right'"
                        (click)="toggleExpandRow(voucher)"></i>
                    </td>
                    <td>{{voucher.date | date:'MMM dd, yyyy'}}</td>
                    <td class="text-center">{{voucher.voucherNo}}</td>
                    <td class="text-center">{{voucher.voucherType}}</td>
                    <td class="text-center">{{voucher.totalDebit}}</td>
                    <td class="text-center">{{voucher.totalCredit}}</td>
                    <td class="text-center">
                      <ng-container *ngIf="voucher.voucherStatus !== 'POSTED'; else postedStatus">
                        <button class="btn btn-sm btn-warning" (click)="updateVoucherStatus(voucher)"
                          ngbTooltip="Click to review and finalize this voucher.">Unposted</button>
                      </ng-container>
                      <ng-template #postedStatus>
                        <span class="badge rounded-pill bg-{{ 'success'  }}"
                          ngbTooltip="This voucher is finalized and cannot be edited."> Posted </span>
                      </ng-template>
                    </td>
                    <td class="actions">
                      <i *ngIf="voucher.voucherStatus !== 'POSTED'; else viewIcon" class="bx bx-edit alert-primary"
                        id="edit-btn"
                        [ngClass]="{'no-event':voucher?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s):finance.voucher.edit' : 'Update voucher'"
                        (click)="upsertVoucher(voucher)">
                      </i>
                      <ng-template #viewIcon>
                        <i class="bx bx-show alert-info" id="view-btn" [ngbTooltip]="'View voucher'"
                          (click)="upsertVoucher(voucher)">
                        </i>
                      </ng-template>
                      <div *ngIf="voucher?.isDeleteInProgress" role="status"
                        class="spinner-border spinner-border-sm text-danger">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="voucher.expanded">
                    <td colspan="9">
                      <div class="row">
                        <div class="col-md-12">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th scope="col" width="150" class="text-center">Account Type</th>
                                <th class="text-center">Account Name</th>
                                <th class="text-center">Particular</th>
                                <th class="text-center">Debit</th>
                                <th class="text-center">Credit</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let entry of voucher.voucherEntryDtos">
                                <td class="text-center">{{ entry.byAccount ? 'byAccount' : 'toAccount'}}</td>
                                <td class="text-center">{{ entry.accountName }}</td>
                                <td class="text-center">{{ entry.particular }}</td>
                                <td class="text-center">{{ entry.byAccount ? entry.amount : '-' }}</td>
                                <td class="text-center">{{ entry.credit ? entry.amount : '-' }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="9">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                      <td colspan="9">No voucher were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="9"
                        *ngIf="searchKeyword && (tableData.content | search : 'name' : searchKeyword).length == 0">
                        No voucher were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
            <div class="row justify-content-between align-items-center pt-3">
              <div class="col-lg-auto">
                <div class="pagination-entries" id="tickets-table_length">
                  <label class="d-flex align-items-center m-0">
                    <span>Items per page</span>
                    <select name="tickets-table_length" aria-controls="tickets-table" [(ngModel)]="tableData.size"
                      (change)="loadTableData(null)"
                      class="custom-select custom-select-sm form-control form-control-sm mx-2">
                      <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                    </select>
                  </label>
                </div>
              </div>
              <div *ngIf="tableData?.content?.length > 0" class="col-lg-auto">
                <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                  [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>